<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > Section Name  </label>
             <CRow >
              <CCol >
              <b-input
                v-model="form.name"
                placeholder="Section Name"
                id="feedback-user"
                class="mb-1"
                :class="errors.name ? 'is-invalid' : ''"
              >
              </b-input>
              <b-form-invalid-feedback >
                Your section name must be filled
              </b-form-invalid-feedback>    
              </CCol>
            </CRow>
          </CCol> 
          </CRow>
          <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)"  variant="outline" color="info">Edit</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import section from '@/services/section'

export default {
name: 'classmodal',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      errors: {},
      errors_from_backend: [],
      form:{
        id: '',
        name: '',
      }
    }
  },
   computed: {
      validationName() {
        return this.form.name.length > 0 
      },
   },
  mounted(){
    
  },
  created () {
    var self = this;

    EventBus.$on('OPEN_MODAL_SECTION', (params) => {
      if(params.data){
        section.getSectionbyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = res.data.id;
          self.form.name = res.data.name;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.name = "";
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      this.loading = true;
      if (this.check_form()) {
      section.createSection(this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false
      }).catch((err) => {
        this.loading = false;
        alert(err.response.data.message);
        //alert(JSON.stringify(err.response.data.errors));
        if (err.response.data.errors != null) {
            this.errors_from_backend = err.response.data.errors;
            console.log(JSON.stringify(err.response.data.errors));
        }
        });
      } else {
        this.loading = false;
      }
    },
    update(id){
      this.show = false;
      section.updateSection(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
     check_form: function(e) {
         this.errors = {};
         if (!this.form.name) {
            this.errors["name"] = "1";
         }

         if (
            this.form.name
         ) {
            return true;
         } else {
            return false;
         }
      },
  }
}
</script>
